<template>
	<div>
		<input type="text" class="form-control" v-model="handler" @input="change">

		<div class="form-group">
			<label>Tag</label>
			<select class="form-control" v-model="type" @change="change">
				<option value="h1">h1</option>
				<option value="h2">h2</option>
				<option value="h3">h3</option>
				<option value="h4">h4</option>
				<option value="h5">h5</option>
				<option value="h6">h6</option>
				<option value="div">div</option>
				<option value="p">p</option>
				<option value="strong">strong</option>
				<option value="em">em</option>
				<option value="del">del</option>
				<option value="ins">ins</option>
			</select>
		</div>

	</div>
</template>

<script>

export default {
	props: ['config', 'name', 'value'],
	data(){
		return {
			handler:'',
			type:'',
		}
	},
	mounted(){
		var text = this.value;
		text = ''+text;
		if(!text) return;

		var dom = htmlToDom(text);
		this.type = dom.tagName.toLowerCase();
		this.handler = dom.innerHTML;

	},
	methods:{
		change(){
			var text = this.handler;

			this.$emit('change',`<${this.type} class="title-seo">${text}</${this.type}>`);
		},
	}

}
</script>
